<template>
  <q-form
    ref="form"
    greedy
    @submit="onSubmit"
  >
    <div class="column q-mt-lg">
      <AppInput
        ref="email"
        v-model.trim="form.email"
        :placeholder="$t('placeholder.emailOrUsername')"
        :rules="[RULES.REQUIRED, RULES.EMAIL]"
        type="email"
        outlined
      />
      <AppPassword
        v-model="form.password"
        :placeholder="$t('placeholder.password')"
        :rules="[RULES.REQUIRED]"
        class="q-mt-md"
        outlined
      />
      <div class="row items-center">
        <div class="col-sm-12 col-lg-6">
          <AppCheckbox
            v-model="form.remember"
            :label="$t('label.rememberMe')"
            class="q-my-sm"
          />
        </div>
        <div class="col-sm-12 col-lg-6 flex justify-lg-end">
          <AppButtonLink
            :label="$t('label.forgotPassword')"
            :to="toRestore"
            class="text-14-400"
          />
        </div>
      </div>
    </div>
    <div class="row q-mt-lg">
      <div class="col-12 flex items-center justify-lg-start justify-center">
        <AppButton
          :disabled="loading || hasErrors"
          :label="$t('button.login')"
          :loading="loading"
          full-width
          text-color="dark"
          icon-right="fl:arrow_right-1"
          type="submit"
          align="between"
          @click="onSubmit"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
import AppCheckbox from 'common/components/AppCheckbox';
import AppInput from 'common/components/AppInput';
import AppPassword from 'common/components/AppPassword';
import AppButton from 'common/components/buttons/AppButton';
import AppButtonLink from 'common/components/buttons/AppButtonLink';
import handleError from 'common/helpers/handleError';
import { notifySuccess, notifyError } from 'common/helpers/notify';
import rules from 'common/helpers/rules';
import { mapActions, mapMutations, mapState } from 'vuex';

const defaultForm = () => ({
  email: undefined,
  password: undefined,
  remember: false,
});

export default {
  name: 'AuthForm',
  components: {
    AppPassword,
    AppCheckbox,
    AppInput,
    AppButtonLink,
    AppButton,
  },
  props: {
    owner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasErrors: false,
      form: defaultForm(),
      loading: false,
      isHidePassword: true,
    };
  },
  computed: {
    ...mapState('app', ['account', 'redirect']),
    RULES: () => rules,
    toRestore() {
      return { name: ENUMS.ROUTES.AUTH.RESTORE };
    },
  },
  watch: {
    'form.email': {
      handler(value) {
        if (value) {
          this.form.email = value.toLowerCase();
        }
      },
    },
  },
  methods: {
    ...mapActions('app', ['auth']),
    ...mapMutations('app', ['setRedirect']),
    async onSubmit() {
      try {
        const isValid = await this.$refs.form.validate();
        if (!isValid) {
          return;
        }
        this.loading = true;
        this.$q.loading.show();

        await this.auth({
          ...this.form,
          password: btoa(this.form.password),
        });

        let route = { name: ENUMS.ROUTES.INDEX };
        if (this.redirect) {
          route = { ...this.redirect };
          this.setRedirect();
        }
        await this.$router.push(route);
        notifySuccess(this.$t('label.youHaveSuccessfullyLogged'));
      } catch (error) {
        if (error.response?.data?.code === 'invalid_password') {
          this.resetForm();
          this.$refs.form.validate();
          notifyError(this.$t('notification.invalidEmailOrPassword'), {
            icon: 'fa fa-circle-xmark',
            textColor: 'black',
          });
          setTimeout(() => {
            this.$refs.form.reset();
          }, 2000);
        } else {
          handleError(error);
        }
      } finally {
        this.$q.loading.hide();
        this.loading = false;
      }
    },
    resetForm() {
      this.form = defaultForm();
    },
  },
};
</script>
